import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import { useEffect, useMemo, useRef } from 'react'

import { useLocation, Route, Switch, useHistory } from 'react-router-dom'

import Drawer from 'components/Drawer/Drawer'

import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Tabs from '@jimmyboys/liita-ui/dist/components/Tabs'
import RouteTransition from '@jimmyboys/liita-ui/dist/components/RouteTransition'

import { tabs } from './tabs/tabs'
import { MemoryRouter } from 'react-router-dom/cjs/react-router-dom'
import RequisitionHistory from './tabs/RequisitionHistory'
import RequisitionDocuments from './tabs/RequisitionDocuments'
import RequisitionDetails from './tabs/RequisitionDetails/RequisitionDetails'
import { openedRequisitionState } from 'store/atoms'
import { useRecoilState } from 'recoil'
import ModalOptions from '@jimmyboys/liita-ui/dist/components/ModalOptions'
import { useReload } from 'store'

import styles from './Requisition.module.sass'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'

const DrawerHeader = (props) => {
	const { data } = props
	const { id } = data
	const { i18n, showDialog } = useGlobal()
	const reload = useReload()

	const commentOptions = [
		{
			value: 'comment',
			text: i18n`Insert comment`,
			action: () => {
				showDialog(
					'CommentDialog',
					i18n`Insert comment`,
					{
						processId: data.processId,
						requisitionId: data?.id,
					},
					false,
					undefined,
					'center',
					'comment-dialog'
				)
					.then(() => {
						reload([
							`/clinical_processes/${data?.processId}/comments`,
						])
					})
					.catch(() => null)
			},
		},
	]

	return (
		<HStack justify='space-between' className={styles['drawer-header']}>
			<h5>#{id}</h5>
			<ModalOptions
				options={commentOptions}
				onSelect={(item) => {
					item && item.action && item.action()
				}}
			>
				<button className={styles['requisition-options']}>
					<Icon
						className={styles['more-icon']}
						width='32px'
						height='32px'
						name={'more'}
					/>
				</button>
			</ModalOptions>
		</HStack>
	)
}

const RequisitionHeader = (props) => {
	const { i18n, gotoAppointment } = useGlobal()
	const { data: requisition } = props
	const innerRouterRef = useRef(null)

	const location = useLocation()
	const { history } = useHistory()

	const sectionTabs = tabs(i18n)

	const selectedTab = useMemo(() => {
		return sectionTabs.find(({ to }) => to === location.pathname)?.to
	}, [location.pathname, sectionTabs])

	useEffect(() => {
		const unListen = history?.listen((location) => {
			if (innerRouterRef.current) {
				innerRouterRef.current.history.replace(location)
			}
		})
		return () => {
			unListen && unListen()
		}
	}, [history])

	return (
		<VStack gap='xsmall' className={styles['header']}>
			<h2>{requisition.type?.name}</h2>
			<strong className={styles['status']}>
				{i18n([requisition?.status?.description || ''])}
			</strong>
			<HStack>
				<small>{i18n`Requested at ${requisition?.requisitionDate?.shortDateFormat}, on`}</small>
				<small
					className={styles['appointment']}
					onClick={() =>
						gotoAppointment(
							requisition?.processId,
							requisition?.appointment?.id
						)
					}
				>
					{`${requisition?.appointment?.medicalSpecialty?.name} #${requisition?.appointment?.id}`}
				</small>
			</HStack>
			<Tabs
				className={styles['section-tabs']}
				selected={selectedTab}
				justify='flex-start'
				tabs={sectionTabs}
			/>
		</VStack>
	)
}

const Requisition = (props) => {
	const { handleClose, data } = props
	const [, setSelectedRequisition] = useRecoilState(openedRequisitionState)

	return (
		<Drawer
			dialogId={'drawer'}
			handleClose={() => {
				setSelectedRequisition(null)
				handleClose()
			}}
			customHeader={<DrawerHeader data={data} />}
			backdrop={false}
		>
			<MemoryRouter>
				<div className={styles['root']}>
					<RequisitionHeader data={data} />
					<div className={styles['content']}>
						<RouteTransition>
							<Switch>
								<Route path={`/`} exact>
									<RequisitionDetails requisition={data} />
								</Route>
								<Route path={`/documents`} exact>
									<RequisitionDocuments
										documents={data?.documents || []}
									/>
								</Route>
								<Route path={`/history`} exact>
									<RequisitionHistory
										history={data.history}
									/>
								</Route>
							</Switch>
						</RouteTransition>
					</div>
				</div>
			</MemoryRouter>
		</Drawer>
	)
}

export default Requisition
